export default "__VITE_ASSET__60d073cd__"